import React from "react";
import { ChefHat } from "lucide-react";

export const EmptyState: React.FC = () => {
  return (
    <div className="flex flex-1 items-center justify-center px-4 py-8">
      <div className="text-center">
        <ChefHat className="mx-auto mb-3 h-14 w-14 opacity-50 sm:mb-4 sm:h-20 sm:w-20" />
        <h3 className="mb-1 text-xl font-bold sm:mb-2 sm:text-2xl">
          Nenhum montador ativo hoje
        </h3>
        <p className="text-sm opacity-75 sm:text-lg">Aguardando montagem...</p>
      </div>
    </div>
  );
};
